/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Doublevalue1Inputs */

const en_entity_doublevalue1 = /** @type {(inputs: Entity_Doublevalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double Value`)
};

const de_entity_doublevalue1 = /** @type {(inputs: Entity_Doublevalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-Wert`)
};

/**
* | output |
* | --- |
* | "Double Value" |
*
* @param {Entity_Doublevalue1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_doublevalue1 = /** @type {((inputs?: Entity_Doublevalue1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Doublevalue1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_doublevalue1(inputs)
	return de_entity_doublevalue1(inputs)
});
export { entity_doublevalue1 as "entity_doubleValue" }